<template>
    <div>
      <div class="modal hide fade" id="modalConvertForm" tabindex="-1" role="dialog" aria-labelledby="modalSaleOrder" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                Create Inventory
              </h4>
              <button type="button" class="close" data-dismiss="modal" @click="clear" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <dl class="row dl-custom font-12">
                    <dt class="col-md-4">Convert No.</dt>
                    <dd class="col-md-8">
                      <input type="text" class="form-control form-control-lite" v-model="convert.convert_no" disabled/>
                    </dd>

                    <dt class="col-md-4">Tanggal</dt>
                    <dd class="col-md-8">
                      <datetime v-model="convert.convert_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                    </dd>

                    <dt class="col-md-4">Warehouse</dt>
                    <dd class="col-md-8">
                      <select v-model="convert.warehouse_no" class="form-control">
                        <option v-for="u in warehouseList" :key="u.id" :value="u.warehouse_no">{{ u.name }}</option>
                      </select>
                    </dd>
                  </dl>
                </div>
                <div class="col-md-6">
                  <dl class="row dl-custom font-12">
                    <dt class="col-md-2">Product No.</dt>
                    <dd class="col-md-10">
                      <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="convert.product_no" @input="setCProduct"/>
                    </dd>
                    <table class="table table-sm table-item table-hover table-striped">
                      <thead>
                        <th style="width: 20%;" class="text-center">Satuan</th>
                        <th style="width: 20%;" class="text-center">Qty</th>
                        <th style="width: 20%;" class="text-center">UoM</th>
                        <th style="width: 20%;" class="text-right">Cost (Per Item)</th>
                        <th style="width: 20%;" class="text-right">Total</th>
                      </thead>
                      <tbody>
                        <tr>
                          <th class="text-center">Pertama</th>
                          <td><input type="text" class="form-control" v-model="convert.qty" @keyup="setRatioCProduct()"/></td>
                          <td>
                            <select v-model="convert.uom_id" class="form-control" @change="setRatioCProduct()" disabled>
                              <option v-for="u in convert.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                            </select>
                          </td>
                          <td class="text-right">Rp. {{ convert.cost | currency }}</td>
                          <td class="text-right">Rp. {{ getBefore | currency }}</td>
                        </tr>
                        <tr>
                          <th class="text-center">Kedua</th>
                          <td><input type="text" class="form-control" v-model="convert.qty_total" @keyup="setRatioCProduct()" disabled/></td>
                          <td>
                            <select v-model="convert.uom_total" class="form-control" @change="setRatioCProduct()" disabled>
                              <option v-for="u in convert.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                            </select>
                          </td>
                          <td class="text-right">Rp. {{ convert.cost_total | currency }}</td>
                          <td class="text-right">Rp. {{ getAfter | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </dl>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-12">
                  <ul class="nav nav-tabs nav-bordered">
                    <li class="nav-item">
                      <a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">
                        Convert To
                      </a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane active" id="general">
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th style="width: 25%">Product</th>
                          <th>Warehouse</th>
                          <th style="width: 10%">Qty</th>
                          <th>UoM</th>
                          <!-- <th style="width: 10%">Qty Convert</th>
                          <th>Uom</th> -->
                          <th style="width: 10%">Total</th>
                          <th>UoM Total</th>
                          <th class="text-right">Price (Per Item)</th>
                          <th class="text-right">Total</th>
                          <th class="text-center">#</th>
                        </thead>
                        <tbody>
                          <tr v-for="(d, index) in convertDetail" :key="d.id" >
                            <td>
                              <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="d.product_no" @input="setProduct(index)"/>
                            </td>
                            <td>
                              <select v-model="d.warehouse_no" class="form-control form-control-lite">
                                <option v-for="u in warehouseList" :key="u.id" :value="u.warehouse_no">{{ u.name }}</option>
                              </select>
                            </td>
                            <!-- <td>
                              <input class="form-control" type="text" id="qty_stock" v-model="d.qty_stock" @keyup="calcRow(index)"/>
                            </td>
                            <td>
                              <select v-model="d.uom_stock" class="form-control form-control-lite">
                                <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                              </select>
                            </td> -->
                            <td class="text-right">
                              <input class="form-control" type="text" id="qty" v-model="d.qty" @keyup="calcRow(index)"/>
                            </td>
                            <td>
                              <select v-model="d.uom_id" class="form-control" disabled>
                                <option v-for="u in d.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                              </select>
                            </td>
                            <td class="text-right">
                              <input class="form-control" type="text" id="qty_total" v-model="d.qty_total" disabled/>
                            </td>
                            <td>
                              <select v-model="d.uom_total" class="form-control form-control-lite" disabled>
                                <option v-for="u in d.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                              </select>
                            </td>
                            <td class="text-right">
                              {{ d.cost | currency }}
                              <!-- <input class="form-control" type="text" id="cost" v-model="d.cost"/> -->
                            </td>
                            <td class="text-right">
                              {{ d.cost_total | currency }}
                              <!-- <input class="form-control" type="text" id="cost_total" v-model="d.cost_total" disabled/> -->
                            </td>
                            <td class="text-center">
                              <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeDetail(index)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right" v-if="getTotal === 0">
                              <i class="fa fa-check"></i>
                            </td>
                            <td class="text-right" v-else>
                              {{ getTotal | currency }}
                            </td>
                            <td></td>
                            <td></td>
                            <td class="text-right" v-if="getTotal === 0">
                              <i class="fa fa-check"></i> Rp. {{ getBefore | currency }}
                            </td>
                            <td class="text-right" v-else>
                              Rp. {{ getTotalCost | currency }}
                            </td>
                            <td></td>
                          </tr>
                          <tr>
                            <td><span @click="addNewLine" class="link-secondary" v-show="getTotal > 0">+ Add Product</span></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                        <tfoot>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" @click="setCost" v-show="getTotal > 0"><i class="fa fa-refresh"></i> Get Cost</button>
            </div>
          </div>
        </div>
      </div>
      <!-- <pre>
        {{ convert }}
      </pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { convertUrl, productUrl, setQtyTotalUrl, getHeader } from '../../config'

export default {
  name: 'ConvertFormModal',
  props: ['convert'],
  components: {
    //
  },
  data () {
    return {
      inventoryData: {},
      uomList: [],
      costTotal: 0,
      selectQty: false,
      searchQueryInventory: '',
      searchQueryOrder: '',
      card1: 'col-md-12',
      card2: null,
      ref: null,
      refNo: null,
      idDetail: null,
      detail: null,
      quantity: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  created () {
    this.ref = this.$route.query.ref
    this.refNo = this.$route.query.refNo
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      brachList: state => state.branches.branchList,
      productListAll: state => state.products.productListAll,
      productListSelect: state => state.products.productListSelect,
      warehouseList: state => state.warehouses.warehouseList
    }),
    productselect: function () {
      var loop = []
      var array = this.productListAll
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getBefore () {
      var total = parseFloat(this.convert.qty) * parseFloat(this.convert.cost)
      return total
    },
    getAfter () {
      var total = parseFloat(this.convert.qty_total) * parseFloat(this.convert.cost_total)
      return total
    },
    convertDetail: function () {
      return this.convert.details.filter(d => d.id !== null)
    },
    getTotal () {
      var qty = 0
      var sum = 0
      var total = 0
      var array = this.convert.details
      var uom = this.convert.uoms.find(d => d.uom_id === this.convert.uom_id)
      var ratio = 0
      if (uom) {
        ratio = uom.ratio
        if (uom.category_id === 1) {
          qty = parseFloat(this.convert.qty_total) * parseFloat(ratio)
        } else if (uom.category_id === 2) {
          qty = parseFloat(this.convert.qty_total) / parseFloat(ratio)
        } else {
          qty = parseFloat(this.convert.qty_total)
        }
        for (let i = 0; i < array.length; i++) {
          sum += parseFloat(array[i].qty_total)
        }
      } else {
        ratio = 0
        qty = 0
        sum = 0
      }
      total = qty - sum
      return total
    },
    getTotalCost () {
      var cost = this.convert.cost_total === null ? 0 : this.convert.cost_total
      var qty = 0
      var sum = 0
      var total = 0
      var costTotal = 0
      var array = this.convert.details
      var uom = this.convert.uoms.find(d => d.uom_id === this.convert.uom_id)
      var ratio = 0
      if (uom) {
        ratio = uom.ratio
        if (uom.category_id === 1) {
          qty = parseFloat(this.convert.qty_total) * parseFloat(ratio)
        } else if (uom.category_id === 2) {
          qty = parseFloat(this.convert.qty_total) / parseFloat(ratio)
        } else {
          qty = parseFloat(this.convert.qty_total)
        }
        for (let i = 0; i < array.length; i++) {
          sum += parseFloat(array[i].cost_total)
        }
      } else {
        ratio = 0
        qty = 0
        sum = 0
      }
      costTotal = parseFloat(cost) * parseFloat(qty)
      total = parseFloat(costTotal) - parseFloat(sum)
      return parseFloat(total)
    }
  },
  methods: {
    async syncCOGS (reply) {
      // convert out
      var data = {
        product_no: this.convert.product_no,
        date: this.convert.convert_date,
        type: 'all',
        company_no: this.convert.company_no
      }
      var resp = {
        error: false,
        message: null
      }
      await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var array = this.convert.details
      for (let i = 0; i < array.length; i++) {
        var data2 = {
          product_no: array[i].product_no,
          date: this.convert.convert_date,
          type: 'all',
          company_no: this.convert.company_no
        }
        await axios.post(productUrl + '/cost/sync', data2, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
          })
      }
      if (reply === 'reply') {
        if (resp.error === false) {
          await this.$swal('Success', resp.message, 'success')
        }
      }
    },
    setRatioCProduct () {
      var cQty = this.convert.qty.toString().replace(/\./g, '').replace(/,/g, '.')
      var cCost = this.convert.cost.toString().replace(/\./g, '').replace(/,/g, '.')
      var qty = 0
      var cost = 0
      // var uom = null
      var ratio = 0
      var getUom = this.convert.uoms.find(d => d.category_id === 1)
      if (getUom) {
        ratio = getUom.ratio
        qty = parseFloat(cQty) * parseFloat(ratio)
        cost = parseFloat(cCost) / parseFloat(ratio)
      } else {
        // uom = this.convert.uoms.find(d => d.uom_id === this.convert.uom_id)
        qty = parseFloat(cQty)
        cost = parseFloat(cCost)
      }
      this.convert.qty_total = qty
      this.convert.cost_total = cost
      var array = this.convert.details
      for (let i = 0; i < array.length; i++) {
        array[i].uom_id = this.convert.uom_id
        array[i].cost = this.convert.cost_total
      }
    },
    async setCProduct () {
      const auth = JSON.parse(window.localStorage.getItem('authUser'))
      var company = auth.user.company_no
      var product = this.productListAll.find(p => p.product_no === this.convert.product_no)
      console.log(productUrl + '/uom/' + this.convert.product_no)
      await axios.get(productUrl + '/uom/' + this.convert.product_no, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var uoms = response.data.data
          this.convert.uoms = uoms
          var getUom = this.convert.uoms.find(d => d.category_id === 1)
          var defUom = this.convert.uoms.find(d => d.category_id === 3)
          if (getUom) {
            this.convert.uom_total = getUom.uom_id
          } else {
            this.convert.uom_total = defUom.uom_id
            this.$swal('Error', 'Item tidak memiliki satuan pembanding atau satuan terkecil. Silahkan tambahkan satuan pada item terlebih dahulu.', 'error')
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var data = {
        date: this.convert.convert_date,
        product_no: this.convert.product_no,
        company: company
      }
      await axios.post(productUrl + '/cost/product', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var array = response.data.data[0]
          var cost = 0
          if (array) {
            cost = array.cost_average === null ? 0 : array.cost_average
          }
          this.convert.cost = parseFloat(cost).toString().replace(/\./g, ',')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      this.convert.uom_id = product.uom_id
    },
    async setCost () {
      const auth = JSON.parse(window.localStorage.getItem('authUser'))
      var company = auth.user.company_no
      var data = {
        date: this.convert.convert_date,
        product_no: this.convert.product_no,
        company: company
      }
      await axios.post(productUrl + '/cost/product', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var array = response.data.data[0]
          var cost = 0
          if (array) {
            cost = array.cost_average === null ? 0 : array.cost_average
          }
          this.convert.cost = parseFloat(cost).toString().replace(/\./g, ',')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })

      this.setRatioCProduct()
      var array = this.convert.details
      var count = array.length
      for (let i = 0; i < count; i++) {
        this.calcRow(i)
      }
    },
    async setProduct (index) {
      var no = 0
      if (this.convert.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      this.convert.details[no].uom_total = this.convert.uom_total
      await axios.get(productUrl + '/uom/' + this.convert.details[no].product_no, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var uoms = response.data.data
          var ud = uoms.find(u => u.category_id === 3)
          if (ud) {
            this.convert.details[no].uom_stock = ud.uom_id
            this.convert.details[no].uom_id = ud.uom_id
          } else {
            this.convert.details[no].uom_stock = this.convert.uom_id
            this.convert.details[no].uom_id = this.convert.uom_id
          }
          this.convert.details[no].uoms = uoms
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    async updateConvert () {
      this.setRatioCProduct()
      var array = this.convert.details
      var count = array.length
      for (let i = 0; i < count; i++) {
        this.calcRow(i)
      }
      await axios.put(convertUrl + '/' + this.convert.id, this.convert, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.setQtyTotal(this.convert.product_no)
          var array = this.convert.details
          console.log(array)
          for (let i = 0; i < array.length; i++) {
            var code = array[i].product_no
            if (code !== null) {
              this.setQtyTotal(code)
            }
            this.setQtyTotal(code)
          }
          this.$swal(
            'Convert',
            'Success update convert',
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
      await this.syncCOGS('no reply')
      await this.$emit('backSaveChild')
    },
    async createConvert () {
      this.setRatioCProduct()
      var array = this.convert.details
      var count = array.length
      for (let i = 0; i < count; i++) {
        this.calcRow(i)
      }
      await axios.post(convertUrl, this.convert, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.setQtyTotal(this.convert.product_no)
          var array = this.convert.details
          console.log(array)
          for (let i = 0; i < array.length; i++) {
            var code = array[i].product_no
            if (code !== null) {
              this.setQtyTotal(code)
            }
          }
          this.$swal(
            'Convert',
            'Success create convert',
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!',
            error.response.data,
            'error'
          )
        })
      await this.$emit('backSaveChild')
    },
    async setQtyTotal (code) {
      var d = new Date()
      var n = d.getFullYear()
      var n1 = n - 1
      this.year = [n1, n]
      var newYear = d.getFullYear()
      var newMonth = d.getMonth() + 1
      var newDate = d.getDate()
      var newSetDate = newYear + '-' + newMonth + '-' + newDate
      var comNo = this.convert.company_no

      await axios.get(setQtyTotalUrl + '?end=' + newSetDate + '&available=true&company_no=' + comNo + '&product_no=' + code, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    addNewLine: function () {
      this.convert.details.push({
        convert_no: null,
        convert_date: null,
        product_no: null,
        qty_stock: 0,
        uom_stock: null,
        qty: 0,
        uom_id: null,
        uoms: [],
        qty_total: 0,
        uom_total: null,
        cost: 0,
        cost_total: 0,
        type: null,
        branch_no: null,
        company_no: this.convert.company_no,
        warehouse_no: this.convert.warehouse_no
      })
      this.state = 'create'
    },
    editDetail: function (id) {
      // var p = this.convert.details.find(d => d.id === id)
      this.idDetail = id
    },
    async removeDetail (index) {
      var no = 0
      if (this.convert.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      var detail = this.convert.details[no]
      if (typeof detail.id === 'undefined') {
        this.convert.details.splice(no, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(convertUrl + '/detail/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.convert.details.splice(no, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    calcRow (index) {
      var no = 0
      if (this.convert.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      var detail = this.convert.details[no]
      if (detail) {
        var uom = detail.uoms.find(d => d.uom_id === detail.uom_total)
        var ratio = uom.ratio
        var cQty = detail.qty.toString().replace(/\./g, '').replace(/,/g, '.')
        var qty = 0
        if (uom.category_id === 1) {
          qty = parseFloat(cQty) * parseFloat(ratio)
        } else if (uom.category_id === 2) {
          qty = parseFloat(cQty) / parseFloat(ratio)
        } else {
          qty = parseFloat(cQty)
        }
        detail.qty_total = qty
        detail.cost = this.convert.cost_total
        detail.cost_total = detail.cost * detail.qty_total
      }
    },
    clear () {
      this.convert.id = null
      this.convert.convert_no = null
      this.convert.convert_date = new Date().toISOString()
      this.convert.product_no = null
      this.convert.qty = 0
      this.convert.qty_total = 0
      this.convert.uom_id = null
      this.convert.uom_total = null
      this.convert.uoms = []
      this.convert.cost = 0
      this.convert.cost_total = 0
      this.convert.type = null
      this.convert.branch_no = null
      this.convert.company_no = null
      this.convert.warehouse_no = null
      this.convert.details = [{
        id: null,
        convert_no: null,
        convert_date: null,
        product_no: null,
        qty_stock: 0,
        uom_stock: null,
        qty: 0,
        uom_id: null,
        qty_total: 0,
        uom_total: null,
        uoms: [],
        cost: 0,
        cost_total: 0,
        type: null,
        branch_no: null,
        company_no: null,
        warehouse_no: null
      }]
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
